export const APPLICANT_ANALYTICS = {
  action: 'applicant_action',
  availability: 'applicant_availability'
} as const

type PosthogCapture = {
  capture: (event: string, properties?: Record<string, unknown>) => void
}

export type ApplicantAction =
  | 'open'
  | 'call'
  | 'note'
  | 'sms'
  | 'meeting'
  | 'add_to_order'
  | 'email_to_applicant'
  | 'email_to_contact'
  | 'email_menu_open'
  | 'status'
  | 'recall'
  | 'cv_email'
  | 'order_status'
  | 'date_commande'

export const captureApplicantAction = (
  posthog: PosthogCapture,
  action: ApplicantAction,
  properties: Record<string, unknown> = {}
) => {
  posthog.capture(APPLICANT_ANALYTICS.action, {
    source: 'react',
    action,
    ...properties
  })
}

export const captureApplicantAvailability = (
  posthog: PosthogCapture,
  action: 'open' | 'tab' | 'validate',
  properties: Record<string, unknown>
) => {
  posthog.capture(APPLICANT_ANALYTICS.availability, {
    source: 'react',
    action,
    ...properties
  })
}
